import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { DASHBOARD_ENTITIES } from '../../utils/const'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ReactLoader from 'react-loader'
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import * as icons from '../../assets/svg/dashboard/criterias'


const DetailsLayout = ({children}) => {
  
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.dashboard)

  const locArray = location.pathname.split('/')
  const facId = locArray.pop()
  const actualPath = locArray.join('/')

  const entitiesList = Object.values(DASHBOARD_ENTITIES.spo)

  const goTo = (link, id) => () => history.replace(`${link}/${id}`, {replace: true})

  const renderItem = ({name, path}, index) => {
    const active = actualPath === path
    return (
      <li onClick={goTo(path, facId)} className={active && styles.active}>
        {icons[name]}
        <p>АП<b>{index+1}</b></p>
      </li>
    )
  }

  const goNext = () => {
    const actualIndex = entitiesList.findIndex(({path}) => path === actualPath)
    const nextIndex = actualIndex + 1 >= entitiesList.length ? 0 : actualIndex + 1
    const nextPath = entitiesList[nextIndex]?.path
    goTo(nextPath, facId)()
  }

  const goPrev = () => {
    const actualIndex = entitiesList.findIndex(({path}) => path === actualPath)
    const prevIndex = actualIndex - 1 < 0 ? entitiesList.length - 1 : actualIndex - 1
    const prevPath = entitiesList[prevIndex]?.path
    goTo(prevPath, facId)()
  }

  if (!parseInt(facId)) return;

  return (
    
    <div className={styles.detailsWrapper}>
      <div>
        <div style={{display: loading ? 'none' : 'block'}}>{children}</div>
        {loading && <ReactLoader color='#5b76e5' />}
      </div>
      <div>
        <FaChevronLeft size={30} color='#5b76e5' onClick={goPrev}/>
        <ul>
          {entitiesList.map(renderItem)}
        </ul>
        <FaChevronRight size={30} color='#5b76e5' onClick={goNext}/>
      </div>
    </div>
  )
}

export default DetailsLayout